function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 0C1.11929 0 0 1.11929 0 2.5V11.5V13.5C0 14.8807 1.11929 16 2.5 16H17.5C18.8807 16 20 14.8807 20 13.5V2.5C20 1.11929 18.8807 0 17.5 0H2.5ZM0 11.5C0 11.372 0.0488155 11.2441 0.146447 11.1464L5.14645 6.14645C5.34171 5.95118 5.65829 5.95118 5.85355 6.14645L11.5 11.7929L14.1464 9.14645C14.3417 8.95118 14.6583 8.95118 14.8536 9.14645L19.3536 13.6464C19.5488 13.8417 19.5488 14.1583 19.3536 14.3536C19.1583 14.5488 18.8417 14.5488 18.6464 14.3536L14.5 10.2071L11.8536 12.8536C11.6583 13.0488 11.3417 13.0488 11.1464 12.8536L5.5 7.20711L0.853553 11.8536C0.658291 12.0488 0.341709 12.0488 0.146447 11.8536C0.0488155 11.7559 0 11.628 0 11.5ZM16 3H14C13.4477 3 13 3.44772 13 4V6C13 6.55228 13.4477 7 14 7H16C16.5523 7 17 6.55228 17 6V4C17 3.44772 16.5523 3 16 3Z",
  fill: "white"
});

function SvgImageActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageActive);
export default __webpack_public_path__ + "static/media/image-active.13f23d71.svg";
export { ForwardRef as ReactComponent };